import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import { IDateRange } from 'libraries/service/resources/model/search/IDateRange';
import { LabelService } from 'libraries/service/label/label.service';

import { Yii } from "libraries/interfaces/Yii";

@Pipe({name: 'dateRange'})
export class DateRangePipe implements PipeTransform {

    public constructor(
        private datePipe: DatePipe,
        private labelService: LabelService,
    ){}

    public transform(dateRange: IDateRange): string {
        const min: string = dateRange.min !== '' ? this.datePipe.transform(dateRange.min, 'shortDate') : '';
        const max: string = dateRange.max !== '' ? this.datePipe.transform(dateRange.max, 'shortDate') : '';

        if (dateRange.missing){
            return Yii.t('wui-sasha-js', 'date absente');
        }

        if (dateRange.min && dateRange.max){
            return this.labelService.completeLabel(
                Yii.t('wui-sasha-js', 'entre le %dateBegin% et le %dateEnd%'),
                {dateBegin: min, dateEnd: max}
            );
        }

        if (dateRange.min){
            return `${Yii.t('wui-sasha-js', 'à partir du')} ${min}`;
        }

        if (dateRange.max){
            return `${Yii.t('wui-sasha-js', 'jusqu\'au')} ${max}`;
        }

        return "";
    }
}
